import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layout-bottom, margin, padding"} maskId="square-outlined-radius-0-stroke-1-IconLayoutBottom"><path d="M20.5 3.5V17.5L3.5 17.5V3.5L20.5 3.5Z" stroke="currentColor"/><path d="M21 20.5H3" stroke="currentColor"/></CentralIconBase>;
}));

export default IconLayoutBottom;
